// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"TotalPrice_priceContainer__fNpli","totalPrice":"TotalPrice_totalPrice__JlRFp","inlineVAT":"TotalPrice_inlineVAT__s6ceL","vat":"TotalPrice_vat__36KGZ"};